<template>
  <div class="mb-4">
    <div id="institution-logo" class="d-flex justify-content-center m-auto">
      <b-img-lazy
        :src="logoSrc || defaultLogo"
      ></b-img-lazy>
    </div>
    <div class="hind-guntur-semi-bold institution-name my-2">{{name}}</div>
    <div class="hind-guntur-regular institution-type">{{type}}</div>
  </div>
</template>

<script>
import Image from '@/assets/images/lembaga/index'

export default {
  props: {
    logoSrc: String,
    name: String,
    type: String
  },
  data () {
    return {
      defaultLogo: Image.default_logo
    }
  }
}
</script>

<style scoped>
#institution-logo{
  width: 185px;
  height: 185px;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
}

#institution-logo img {
  max-width: 172px;
  max-height: 166px;
  display:block;
  margin:auto;
}

.institution-name {
  max-width: 178px;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin: auto;
  color: #000000;
}

.institution-type {
  max-width: 172px;
  max-height: 17px;
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  margin: auto;
  color: rgba(0, 0, 0, 0.7);
}

@media screen and (max-width: 1280px) {
  #institution-logo{
    width: 150px;
    height: 150px;
    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
  }

  #institution-logo img {
    max-width: 150px;
    max-height: 155px;
    display:block;
    margin:auto;
  }

  .institution-name {
    max-width: 148.2px;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #333333;
  }

  .institution-type {
    max-width: 154.09px;
    max-height: 13px;
    font-size: 12px;
    line-height: 13px;
    text-align: center;
    color: #828282;
  }
}

@media screen and (max-width: 320px) {
  #institution-logo{
    width: 150px;
    height: 155px;
  }

  #institution-logo img {
    max-width: 150px;
    max-height: 155px;
    display:block;
    margin:auto;
  }
}
</style>
